import {Component, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {tap} from 'rxjs/operators';
import {forkJoin} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {NgForOf} from '@angular/common';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    imports: [
        NgForOf
    ]
})
export class HelpComponent implements OnInit {
  title = {};
  short_text = {};
  included_help = ['dashboard', 'site list', 'site', 'map tool'];

  constructor(public http: HttpClient, public route: ActivatedRoute) {
  }

  ngOnInit(): void {
    const helpObs = this.included_help.map((help_section) => {
      return this.http.get(`${environment.baseUrl}/help/${help_section}`).pipe(
        tap((help: any) => {
          this.title[help_section] = help.title;
          // help.short_text = help.short_text);
          this.short_text[help_section] = help.short_text;
        }));
    });
    forkJoin(helpObs).subscribe(() => {
      document.getElementById(this.route.snapshot.fragment)?.scrollIntoView()

      this.route.fragment.subscribe(() => {
        document.getElementById(this.route.snapshot.fragment)?.scrollIntoView()
      })
    })
  }

}
